/* eslint-disable default-param-last */
import IRBState from 'models/irb';
import { IRB_ACTIONS } from 'actions/irb';

const IRBReducer = (state = IRBState, action) => {
  switch (action.type) {
    case IRB_ACTIONS.GET_IRB_APPROVAL_DETAILS:
      return {
        ...state,
        irbApprovalDetails: action.payload
      };
    case IRB_ACTIONS.GET_PI_DETAILS:
      return {
        ...state,
        piDetails: action.payload
      };
    default:
      return state;
  }
};

export default IRBReducer;
